import React from 'react'
import { Navigate } from 'react-router-dom';

export const Auth = ({children}) => {
    // if(localStorage.getItem('token')){

    //     return children;
    // }
    const token = localStorage.getItem('token');
    if (token === '650bdeb49d0d4331b0da71b3') {
      return children;
    }
   
  return <Navigate to='/admin'/>
}